import React, {useState} from 'react';
import '../Keyboard.css';
type KeyProps = {
    label?: string;
    onPress: () => void;
}

const SubmitKey: React.FC<KeyProps> = ({label, onPress}) => {
    const [pressed, setPressed] = useState(false);

    const handleKeyPress = () => {
        setPressed(true);
        setTimeout(() => setPressed(false), 200); // 按键后的状态持续时间
        onPress();
    };

    return (
        <div
            className={`keyboard-submit-btn my-roboto-regular ${pressed ? 'key-pressed' : ''} width-346 margin-left-right-auto`}
            onClick={handleKeyPress}>
            <div className="submit-text">
                {label}
            </div>
        </div>
    );
};

export default SubmitKey;